/**
 * @Author Louis Scheepers
 *
 * This class handles the drag and drop events on the dashboard.
 * It by no means handles what gets shown on the dashboard only what should happen during drag and drop events.
 * These events in turn change values in the livewire component that is responsible for displaying the actual content inside the box
 */

import { ModuleType } from "./Classes/Enums/ModyleType";

document.addEventListener('DOMContentLoaded', (event) => {
    /**
     * Generates a transparent ghost image when dragging boxes/modules
     */
    document.addEventListener("dragstart", function( event ) {
    }, false);

    let sourceElement;
    function handleDragStart(e) {
        // Generate a transparent ghost image
        let img = new Image();
        img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=';
        e.dataTransfer.setDragImage(img, 0, 0);

        e.dataTransfer.setData('text/plain', e.target.id);
        sourceElement = e.target.id;
    }

    function handleDragEnd(e) {
        // console.log("drag end: " + e.target.id);
    }

    function handleDragOver(e) {
        e.preventDefault();
        if (e.target.id !== "undefined" || e.target.id !== "" || e.target.id !== null) {
            if (isValidBox(sourceElement) || isValidBox(this.id)) {
                if (isValidBox(sourceElement)) {
                    let sourceBox = document.getElementById(sourceElement);
                    sourceBox.querySelector('.card').classList.add("box-source");
                }

                if (isValidBox(this.id)) {
                    let targetBox = document.getElementById(this.id);
                    let targetCard = targetBox.querySelector('.card');
                    targetCard.classList.add('box-target');
                }
            }
        }
    }

    function handleDragEnter(e) {
        //Do Nothing
    }

    function handleDragLeave(e) {
        if (e.target.id !== "undefined" || e.target.id !== "") {
            let thisElement = document.getElementById(this.id);
            let thisElementCard = thisElement.querySelector('.card');
            if (thisElementCard != null) {
                thisElementCard.classList.remove("box-target");
            }
        }
    }

    function handleDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        const module = e.dataTransfer.getData('text');

        if (isValidModule(module) || isValidBox(module)) {
            let targetBox = document.getElementById(this.id);
            let targetModule = targetBox.querySelector('#boxModule');

            if (targetModule != null) {
                if (isValidModule(module)) {
                    targetModule.value = moduleToNumber(module);
                } else {
                    showTable(targetModule.parentElement.parentElement.id, targetModule.value);
                    console.log(module + " is not a valid module");
                }

                if (isValidBox(module)) {
                    let sourceBox = document.getElementById(module);
                    let sourceModule = sourceBox.querySelector("#boxModule");
                    let targetModuleValue = targetModule.value;
                    targetModule.value = sourceModule.value;
                    sourceModule.value = targetModuleValue;

                    removeBorderHighlights(targetBox, false);
                    removeBorderHighlights(sourceBox, true);
                    sourceModule.dispatchEvent(new Event('input'));
                    //
                    // if(isTableBox(targetModule.value) && isTableBox(sourceModule.value)){
                    //
                    //     console.log("Both Boxes are table boxes");
                    let targetInnerModule = document.getElementById(this.id + "Module");
                    let sourceInnerModule = document.getElementById(module + "Module");

                    if(parseInt(targetModule.value) !== 0){
                        targetInnerModule.value = targetModule.value;
                        targetInnerModule.dispatchEvent(new Event('input'));
                    }

                    if(parseInt(sourceModule.value) !== 0){
                        sourceInnerModule.value = sourceModule.value;
                        sourceInnerModule.dispatchEvent(new Event('input'));
                    }

                } else {
                    showTable(targetModule.parentElement.parentElement.id, targetModule.value);

                    console.log(module.id + " is not a valid box");
                }
                targetModule.dispatchEvent(new Event('input'));
                window.registerPopupEvents();
            } else {
                console.log("Target Module is null");
            }

        } else {
            console.log("Not Valid Drop Target");
        }
    }

    let dragItems = document.querySelectorAll('.drag');
    dragItems.forEach(function(item) {
        item.addEventListener('dragstart', handleDragStart, false);
        item.addEventListener('dragover', handleDragOver, false);
        item.addEventListener('dragenter', handleDragEnter, false);
        item.addEventListener('dragleave', handleDragLeave, false);
        item.addEventListener('dragend', handleDragEnd, false);
        item.addEventListener('drop', handleDrop, false);
    });

    $(window).on('shown.bs.modal', function (){
        let dragItems = document.querySelectorAll('.drag');
        dragItems.forEach(function(item) {
           item.setAttribute('draggable', 'false');
        });
    });

    $(window).on('hidden.bs.modal', function (){
        let dragItems = document.querySelectorAll('.drag');
        dragItems.forEach(function(item) {
            item.setAttribute('draggable', 'true');
        });
    });
});

$(document).ready(function() {

    window.mobileDrop = function(moduleId) {
        if ($(window).width() < 769) {
            const module = moduleId;
            if (isValidModule(module)) {
                let targetBox = document.getElementById('box3');
                let targetModule = targetBox.querySelector('#boxModule');
                targetModule.value = moduleToNumber(module);
                targetModule.dispatchEvent(new Event('input'));
            }
        }
    };

    window.switchChart = function(moduleId, boxId) {

        console.log('Switch Analysis to module ' + moduleId + ' on ' + boxId);

        let box = document.getElementById(boxId);
        let boxModule = box.querySelector("#boxModule");
        boxModule.value = moduleId;
        boxModule.dispatchEvent(new Event('input'));
    };

    window.switchCFS = function(method, boxId) {
        Livewire.emit('switchCFSMethod' + boxId);
    };

});

let validModules = ['cico', 'ino', 'avd', 'pl', 'bs', 'cfs', 'ar', 'ddo',
    'tcs', 'ret', 'ap', 'cdo', 'tsp', 'im', 'inas', 'inaq', 'plr', 'bsr',
];

let validBoxes = ['box1', 'box2', 'box3', 'box4', 'box5', 'box6', 'box7', 'box8'];
let modulePairs = {
    'cico': 1,
    'ino': 2,
    'avd': 3,
    'pl': 4,
    'bs': 5,
    'cfs': 6,
    'ar': 7,
    'ddo': 8,
    'tcs': 9,
    'ret': 10,
    'ap': 11,
    'cdo': 12,
    'tsp': 13,
    'im': 14,
    'inas': 15,
    'inaq': 16,
    'plr': 17,
    'bsr': 18,
}

let tableBoxes = [
     4,
     5,
     6,
]

function isTableBox(module){
    return tableBoxes.includes(module);
}

function isValidModule(module) {
    return validModules.includes(module);
}

function isValidBox(box) {
    return validBoxes.includes(box);
}

function moduleToNumber(module) {
    return modulePairs[module];
}

function removeBorderHighlights(element, isSource) {
    element = element.querySelector(".card");
    element.classList.remove((isSource) ? "box-source" : "box-target");
}

function showTable(box, module){
    if(module == 4,5,6)
    {
        console.log("removing override for table: #annex" + box[box.length -1]);
        $('#' + "annex"  + box[box.length -1]).removeClass("override");
    }
}
